import React from 'react'
import { useBogo } from '@mc/bogo-utils'
import { useFreeTrial } from '@mc/free-trial'
import { withI18nContext } from '@mc/i18n'
import { BundleLegal } from '../../experiments/prcng-897_v1_standalone-bundle'
import { i18nInstance } from '../../i18n/i18nInstance'
import { BogoLegal } from './legals/BogoLegal'
import { RegularLegal } from './legals/RegularLegal'
import { SubmitLegal } from './legals/SubmitLegal'
import { TrialLegal } from './legals/TrialLegal'

interface EmailCaptureLegalProps {
  className?: string
  isGift?: boolean
  isAllAccessBundle?: boolean // prcng-897_v1
  kind?: 'email-capture' | 'submit'
  ctaText?: string
}

const EmailCaptureLegalComponent = ({
  className = '',
  isGift,
  isAllAccessBundle, // prcng-897_v1
  kind = 'email-capture',
  ctaText,
}: EmailCaptureLegalProps) => {
  const { isBogoOfferEligible } = useBogo({ isGift })
  const { trial } = useFreeTrial({ isGift })
  const classes = `${className} mc-mb-4 mc-text-small`

  if (isAllAccessBundle) {
    return <BundleLegal className={classes} />
  }

  if (isBogoOfferEligible) {
    return <BogoLegal className={classes} />
  }

  if (trial.eligible) {
    return <TrialLegal className={classes} />
  }

  if (kind === 'submit') {
    return <SubmitLegal className={classes} ctaText={ctaText} />
  }

  return <RegularLegal className={classes} />
}

export const EmailCaptureLegal = withI18nContext(i18nInstance)(
  EmailCaptureLegalComponent,
)
